var app = angular.module('leonardo');

var UnitService = function(BaseRestService, RestangularProvider, ConfigThemeService, Upload, $q) {
  var service = new BaseRestService('unit');

  service.getAllByProperty = function(params) {
    return RestangularProvider.all('unit').customGET('distinct-numbers-list', params);
  };

  service.deleteAll = function(params) {
    return RestangularProvider.all('unit').customPOST(params, 'bulk-delete');
  };

  service.unDeleteAll = function(params) {
    return RestangularProvider.all('unit').customPOST(params, 'bulk-undelete');
  };

  service.importExcel = function(params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/unit/import-excel/'),
      arrayKey: '',
      data: {
        account: params.account,
        file: params.file[0].file,
        response_email_recipients: params.response_email_recipients
      }
    });
  };

  service.getUnitOnBasisOfMultipleProperty = function(data){
    return RestangularProvider.all('unit').customPOST(data, 'multi-property');
  }

  service.getMakeReadyBoard = function(params) {
    return RestangularProvider.all('unit').customGET('make-ready-board', params);
  };

  service.getFields = function(params) {
    return RestangularProvider.all('unit').customGET('fields', params);
  };

  service.exportExcel = function(params) {
    return RestangularProvider.all('unit').customGET('export-units', params);
  };

  var originalGetList = service.getlist;

  service.getlist = function(options, method) {
    var promise = originalGetList(options, method);
    var defer = $q.defer();
    promise.then(function(list) {
      var results = list.results ? list.results : list;
      angular.forEach(results, function (value){
        value.name = value.unit_type ? value.unit_type.name + '-' : '';
        value.name += value.name ? value.number + '-': '';
        value.name += value.building ? value.building + '-' : '';
        value.name = value.name.slice(0, -1);
      });
      defer.resolve(results);
    }, function(error) {
      defer.reject(error);
    });
    return promise;
  };

  var originalGetAll = service.getAll;

  service.getAll = function(options, notUpdated) {
    var promise = originalGetAll(options, notUpdated);
    var defer = $q.defer();
    promise.then(function(list) {
      var results = list.results ? list.results : list;
      angular.forEach(results, function (value){
        value.name = value.unit_type ? value.unit_type.name + '-' : '';
        value.name += value.name ? value.number + '-': '';
        value.name += value.building ? value.building + '-' : '';
        value.name = value.name.slice(0, -1);
      });
      if (!notUpdated) {
        service.setCollection(list);
      }
      defer.resolve(results);
    }, function(error) {
      defer.reject(error);
    });
    return promise;
  };

  service.TURN_STATUS_OK = '1';
  service.TURN_STATUS_WARNING = '2';
  service.TURN_STATUS_DANGER = '3';

  service.TURN_STATUS_OPTIONS = [
    {
      id: service.TURN_STATUS_OK,
      name: 'Ok'
    },
    {
      id: service.TURN_STATUS_WARNING,
      name: 'Warning'
    },
    {
      id: service.TURN_STATUS_DANGER,
      name: 'Danger'
    }
  ];

  return service;
};

app.factory('UnitService', ['BaseRestService', 'Restangular', 'ConfigThemeService', 'UploadBase', '$q', UnitService]);
